document.documentElement.classList.add('gh-js');

document.addEventListener('DOMContentLoaded', function () {
  // Sections each include this file, so DOMContentLoaded can fire this callback
  // more than once — guard so init only runs a single time.
  if (window.__ghInit) return;
  window.__ghInit = true;
  initReveal();
  initProductGallery();
  initVariantPicker();
});

function initReveal() {
  var els = document.querySelectorAll('.gh-reveal');
  if (!els.length) return;

  function reveal(el) { el.classList.add('gh-visible'); }

  if (!('IntersectionObserver' in window)) {
    els.forEach(reveal);
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        reveal(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  els.forEach(function (el, i) {
    el.style.setProperty('--gh-delay', (i % 6) * 90 + 'ms');
    observer.observe(el);
  });

  // Safety net: never leave anything permanently invisible, no matter what
  // the observer does (covers edge cases like elements already fully
  // scrolled past on load, or a browser quirk with IntersectionObserver).
  setTimeout(function () {
    els.forEach(reveal);
  }, 1500);
}

function initProductGallery() {
  var gallery = document.querySelector('[data-gh-gallery]');
  if (!gallery) return;
  var main = gallery.querySelector('[data-gh-gallery-main]');
  if (!main) return;
  bindGalleryThumbs();
}

function bindGalleryThumbs() {
  var gallery = document.querySelector('[data-gh-gallery]');
  if (!gallery) return;
  var main = gallery.querySelector('[data-gh-gallery-main]');
  var thumbs = gallery.querySelectorAll('[data-gh-gallery-thumb]');
  if (!main || !thumbs.length) return;
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.getAttribute('data-full');
      main.setAttribute('src', src);
      thumbs.forEach(function (t) { t.classList.remove('gh-thumb-active'); });
      thumb.classList.add('gh-thumb-active');
    });
  });
}

// Swaps the gallery to a color-specific set of photos: {full, thumb} objects.
// Used when a variant swatch carries a data-images list (multiple photos per
// color), instead of the single data-image fallback.
function setGalleryImages(images) {
  var gallery = document.querySelector('[data-gh-gallery]');
  if (!gallery || !images || !images.length) return;
  var main = gallery.querySelector('[data-gh-gallery-main]');
  var thumbsWrap = gallery.querySelector('.gh-product-thumbs, .nc-product-thumbs');
  if (main) main.setAttribute('src', images[0].full);
  if (!thumbsWrap) return;
  thumbsWrap.innerHTML = '';
  images.forEach(function (img, i) {
    var el = document.createElement('img');
    el.setAttribute('data-gh-gallery-thumb', '');
    if (i === 0) el.classList.add('gh-thumb-active');
    el.setAttribute('data-full', img.full);
    el.setAttribute('src', img.thumb);
    el.setAttribute('loading', 'lazy');
    el.setAttribute('alt', '');
    thumbsWrap.appendChild(el);
  });
  bindGalleryThumbs();
}

function initVariantPicker() {
  var form = document.querySelector('[data-gh-product-form]');
  if (!form) return;
  var variantsScript = form.querySelector('[data-gh-variants]');
  var idInput = form.querySelector('input[name="id"]');
  var priceEl = document.querySelector('[data-gh-price]');
  var compareEl = document.querySelector('[data-gh-compare-price]');
  var submitBtn = form.querySelector('[data-gh-submit]');
  if (!variantsScript || !idInput) return;

  var variants;
  try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }
  if (!variants.length) return;

  var swatchButtons = form.querySelectorAll('[data-gh-option-btn]');
  var selection = variants[0].options.slice();

  function findVariant() {
    return variants.find(function (v) {
      return v.options.every(function (opt, idx) { return opt === selection[idx]; });
    });
  }

  function render() {
    var variant = findVariant();
    if (!variant) return;
    idInput.value = variant.id;
    if (priceEl) priceEl.textContent = variant.price_formatted;
    if (compareEl) {
      if (variant.compare_at_price_formatted) {
        compareEl.textContent = variant.compare_at_price_formatted;
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (submitBtn) {
      if (variant.available) {
        submitBtn.disabled = false;
        submitBtn.textContent = submitBtn.getAttribute('data-label-available') || 'Add to cart';
      } else {
        submitBtn.disabled = true;
        submitBtn.textContent = submitBtn.getAttribute('data-label-sold-out') || 'Sold out';
      }
    }
  }

  var galleryMain = document.querySelector('[data-gh-gallery-main]');
  var galleryThumbs = document.querySelectorAll('[data-gh-gallery-thumb]');

  swatchButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var pos = parseInt(btn.getAttribute('data-position'), 10);
      selection[pos] = btn.getAttribute('data-value');
      swatchButtons.forEach(function (b) {
        if (parseInt(b.getAttribute('data-position'), 10) === pos) b.classList.remove('gh-swatch-active');
      });
      btn.classList.add('gh-swatch-active');

      var imagesAttr = btn.getAttribute('data-images');
      if (imagesAttr) {
        try { setGalleryImages(JSON.parse(imagesAttr)); } catch (e) {}
      } else {
        var image = btn.getAttribute('data-image');
        if (image && galleryMain) {
          galleryMain.setAttribute('src', image);
          galleryThumbs.forEach(function (t) { t.classList.remove('gh-thumb-active'); });
        }
      }

      render();
    });
  });

  var activeSwatch = form.querySelector('[data-gh-option-btn].gh-swatch-active');
  var activeImages = activeSwatch && activeSwatch.getAttribute('data-images');
  if (activeImages) {
    try { setGalleryImages(JSON.parse(activeImages)); } catch (e) {}
  }

  render();
}
